<template>
  <div class="evaluation-list">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="`${$t('page.users.evaluationList.pending')}(${pendingCount})`" name="0"></el-tab-pane>
      <el-tab-pane :label="`${$t('page.users.evaluationList.completed')}(${completedCount})`" name="1"></el-tab-pane>
    </el-tabs>

    <div class="list-container" v-loading="loading">
      <!-- 待评价列表 -->
      <div v-if="activeName === '0' && orderList.length > 0">
        <div v-for="(item, index) in orderList" :key="index" class="evaluation-item">
          <div class="item-content">
            <div class="product-info">
              <img :src="item.img" alt="" class="product-image">
              <div class="product-details">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-sku" v-if="item.sku">{{ item.sku }}</div>
                <div class="product-price">{{ GLOBAL.shopPayCurrency }}{{ item.price }}</div>
              </div>
            </div>
            <div class="action-area">
              <el-button 
                class="evaluate-btn" 
                @click="goEvaluation(item)"
              >
                {{ $t('page.users.evaluationList.goEvaluate') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 已评价列表 -->
      <div v-if="activeName === '1' && orderList.length > 0">
        <div v-for="(item, index) in orderList" :key="index" class="evaluated-item">
          <div class="eval-time">{{ $t('page.users.evaluationList.evaluationTime') }}：{{ item.comment_time }}</div>
          <div class="eval-status">{{ item.content }}</div>
          <div class="eval-content">
            <div class="product-section">
              <img :src="item.img" alt="" class="product-thumb">
              <div class="product-info-text">
                <div class="product-name">{{ item.name }}</div>
                <div class="product-spec" v-if="item.sku">{{ item.sku }}</div>
                <div class="product-price">{{ GLOBAL.shopPayCurrency }}{{ item.price }}</div>
              </div>
            </div>
            <!-- <div class="comment-section">
              <div class="rating-stars">
                <el-rate v-model="item.star" disabled show-score text-color="#ff9900"></el-rate>
              </div>
              <div class="comment-text">{{ item.comment }}</div>
              <div class="comment-images" v-if="item.pics && item.pics.length > 0">
                <img v-for="(pic, idx) in item.pics" :key="idx" :src="pic" class="comment-img">
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="empty-box" v-if="orderList.length == 0 && !loading">
        <img src="@/assets/images/noorder.png" alt="">
        <p>{{ activeName == '0' ? $t('page.users.evaluationList.noPendingOrders') : $t('page.users.evaluationList.noEvaluationRecords') }}</p>
      </div>
    </div>

    <div class="pagination-container" v-if="total > 0">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluationList',
  data() {
    return {
      activeName: '0',
      pendingCount: 0,
      completedCount: 0,
      orderList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleClick(tab, event) {
      this.currentPage = 1

      console.log(this.activeName)
      this.getList()
      
    },
    getList() {
      this.loading = true
      const data = {
        states: this.activeName,
        page: this.currentPage,
        pageSize: this.pageSize
      }
      
      this.$axios.post('/api/center/getOrderCommentList', data).then(res => {
        const list = res.data.list || res.data || []
        // 处理数据结构，将 sub[0] 的信息提取到主对象
        this.orderList = list
        this.pendingCount = res.data.no_comment_num
        this.completedCount = res.data.comment_num
        this.total = res.data.total || this.orderList.length
        this.loading = false
        
        // 更新标签计数
        // this.updateTabCounts()
      }).catch(err => {
        this.loading = false
      })
    },
    // 获取已评价列表
    getEvaluationList() {
      this.loading = true
      this.$axios.post('/api/center/getCommentList', {
        page: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        const list = res.data.list || res.data || []
        // 处理已评价数据
        this.orderList = list.map(item => {
          const subItem = item.sub && item.sub[0] ? item.sub[0] : {}
          return {
            ...item,
            img: subItem.img || '',
            name: subItem.name || '',
            price: subItem.price || 0,
            sku: subItem.sku || '',
            star: item.star || 0,
            comment: item.comment || '',
            pics: item.pics ? (typeof item.pics === 'string' ? JSON.parse(item.pics) : item.pics) : [],
            createtime: item.createtime || ''
          }
        })
        this.total = res.data.total || this.orderList.length
        this.loading = false
      }).catch(err => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      if (this.activeName == 3) {
        this.getList()
      } else {
        this.getEvaluationList()
      }
      
    },
    goEvaluation(item) {
      // 将评价数据存储到 Vuex
      const evaluationData = {
        id: item.id,
        orderId: item.orderid,
        orderNo: item.orderid,
        productId: item.productId,
        name: item.name,
        img: item.img,
        price: item.price,
        num: item.num,
        sku: item.sku,
        total: item.total,
        delivery: item.delivery,
        deliveryfee: item.deliveryfee,
        states: item.states,
        sub: item.sub
      }
      
      console.log('存储到 Vuex 的数据:', evaluationData)
      this.$store.commit('SET_EvaluationInfo', evaluationData)
      
      // 跳转到评价页面
      this.$router.push({
        path: '/users/evaluation_confirm'
      })
    },
    // updateTabCounts() {
    //   // 获取待评价数量
    //   this.$axios.get('/api/center/getReplylist', { params: { status: 0 } }).then(res => {
    //     this.pendingCount = res.data.total || (res.data.list || res.data || []).length
    //   })
    //   // 获取已评价数量
    //   this.$axios.get('/api/center/getReplylist', { params: { status: 1 } }).then(res => {
    //     this.completedCount = res.data.total || (res.data.list || res.data || []).length
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
.evaluation-list {
  padding: 20px;
  background-color: #fff;
  min-height: 600px;

  .list-container {
    margin-top: 20px;
  }

  .evaluation-item {
    border: 1px solid #EBEEF5;
    margin-bottom: 15px;
    padding: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }

    .item-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .product-info {
        display: flex;
        align-items: center;
        flex: 1;

        .product-image {
          width: 100px;
          height: 100px;
          border-radius: 4px;
          margin-right: 20px;
          object-fit: cover;
        }

        .product-details {
          flex: 1;

          .product-name {
            color: #333;
            font-size: 14px;
            line-height: 1.5;
            margin-bottom: 8px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            overflow: hidden;
          }

          .product-sku {
            color: #999;
            font-size: 12px;
            margin-bottom: 8px;
          }

          .product-price {
            color: #E93323;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }

      .action-area {
        width: 120px;
        text-align: right;

        .evaluate-btn {
          padding: 8px 20px;
          border: 1px solid #DCDFE6;
          color: #606266;
          background: #fff;
          border-radius: 3px;
          font-size: 14px;
          cursor: pointer;

          &:hover {
            border-color: #E93323;
            color: #E93323;
          }
        }
      }
    }
  }

  // 已评价列表样式
  .evaluated-item {
    border: 1px solid #EBEEF5;
    margin-bottom: 15px;
    padding: 20px;
    background: #fff;

    &:last-child {
      margin-bottom: 0;
    }

    .eval-time {
      color: #666;
      font-size: 13px;
      margin-bottom: 10px;
    }

    .eval-status {
      color: #E93323;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    .eval-content {
      .product-section {
        display: flex;
        align-items: flex-start;
        padding-bottom: 15px;
        border-bottom: 1px solid #F5F5F5;
        margin-bottom: 15px;

        .product-thumb {
          width: 60px;
          height: 60px;
          border-radius: 4px;
          margin-right: 15px;
          object-fit: cover;
        }

        .product-info-text {
          flex: 1;

          .product-name {
            color: #333;
            font-size: 14px;
            line-height: 1.5;
            margin-bottom: 5px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            overflow: hidden;
          }

          .product-spec {
            color: #999;
            font-size: 12px;
            margin-bottom: 5px;
          }

          .product-price {
            color: #E93323;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }

      .comment-section {
        .rating-stars {
          margin-bottom: 10px;
        }

        .comment-text {
          color: #333;
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 10px;
        }

        .comment-images {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;

          .comment-img {
            width: 80px;
            height: 80px;
            border-radius: 4px;
            object-fit: cover;
            cursor: pointer;
            transition: transform 0.2s;

            &:hover {
              transform: scale(1.05);
            }
          }
        }
      }
    }
  }

  .pagination-container {
    margin-top: 30px;
    text-align: right;
  }

  .empty-box {
    text-align: center;
    padding: 80px 0;

    img {
      width: 150px;
      margin-bottom: 20px;
    }

    p {
      color: #999;
      font-size: 14px;
    }
  }

  ::v-deep .el-tabs__item.is-active {
    color: #E93323;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: #E93323;
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #E93323;
  }

  ::v-deep .el-tabs__item {
    font-size: 14px;
    padding: 0 20px;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    background-color: #EBEEF5;
  }
}
</style>
